import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    padding: 0px 16px 0px 16px;
    flex-direction: column;
  `,
  headerSpacing: css`
    margin-top: 24px;
  `,
  heading: css`
    width: 100%;
    max-width: 420px;
  `,
  hidden: css`
    visibility: hidden;
  `,
  disabled: css`
    pointer-events: none;
  `,
  content: css`
    padding: 0px 16px;
  `,
  emailLabel: css`
    color: ${colors.slate};
    font-size: 13px;
    margin-top: 30px;
  `,
  email: css`
    color: ${colors.slate};
    font-size: 16px;
  `,
  emailDisclaimer: css`
    color: ${colors.slate};
    font-size: 13px;
  `,
  subscriptionDisclaimer: css`
    color: ${colors.prussian};
    font-size: 16px;
  `,
  dependents: css``,
  closeIcon: css`
    position: absolute;
    top: 100px;
    left: 50px;
    cursor: pointer;
    @media (max-width: 480px) {
      top: 80px;
      left: 20px;
    }
  `,
  addSectionContainer: css`
    margin-top: 8px;
    margin-bottom: 40px;
  `,
  addIcon: css`
    display: flex;
    align-items: flex-end;
  `,
  addText: css`
    font-family: 'Montserrat Medium';
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: -0.6px;
    text-decoration: underline;
    color: ${colors.jungle};
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  `,
  addTextDisabled: css`
    font-family: 'Montserrat Medium';
    color: ${colors.slate};
    font-size: 16px;
    cursor: pointer;
  `,
  iconOverrides: css`
    color: ${colors.jungle};
    font-size: 16px;
    vertical-align: bottom;
    height: 22px !important;
    width: 22px !important;
    cursor: pointer;
    margin-right: 8px;
  `,
  secondaryCta: css`
    margin-right: 16px;
  `,
  footer: css`
    display: flex;
    justify-content: flex-end;
  `,
  notificationsIcon: css`
    padding-right: 4px;
    font-size: 16px;
  `,
  disableText: css`
    color: ${colors.silver};
    cursor: not-allowed;
  `,
  districtGroup: css`
    border: 0;
    margin: 0;
    padding: 0;
    min-inline-size: 0;
  `,
  legend: css`
    padding: 0;
    margin: 0;
    display: block;
    width: 100%;
  `,
  districtNameContainer: css`
    padding-bottom: 12px;
  `,
  districtName: css`
    text-transform: capitalize;
    padding-bottom: 8px;
  `,
  separator: css`
    padding-top: 40px;
  `,
  divider: css`
    width: 100%;
    height: 3px;
    flex-grow: 0;
    background-color: ${colors.silver};
    margin-top: 29px;
    margin-bottom: 16px;
  `,
  horizontalPadding: css`
    padding: 0px 16px;
  `,
  buttonManageMyself: css`
    display: flex;
    align-items: center;
    & .MuiButton-root {
      background: ${colors.white} !important;
    }
    & .MuiButton-root:hover {
      background: ${colors.white} !important;
    }
    margin-top: 16px;
  `,
  emptyState: css`
    display: flex;
    margin-top: 40px;
    justify-content: center;
    flex-wrap: wrap;

    p {
      margin-top: 16px;
      margin-bottom: 16px;
      text-align: center;
      font-family: 'Proxima Nova', Arial, Helvetica, sans-serif;
      color: ${colors.prussian};
      font-size: 16px;
      line-height: 24px;
    }
    img {
      width: 390px;
      height: 128px;
      @media (max-width: 480px) {
        width: 340px;
      }
    }
  `,
  dismissButton: css`
    margin-top: 16px;
  `,
  childNotUpToDateBanner: css`
    margin-bottom: 40px;
  `,
  pendingDistrictName: css`
    font-family: 'Proxima Nova-Bold', Arial, Helvetica, sans-serif;
    color: ${colors.prussian};
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    text-transform: capitalize;
    display: block;
  `,
  pendingInfo: css`
    font-family: 'Proxima Nova', Arial, Helvetica, sans-serif;
    color: ${colors.prussian};
    font-size: 16px;
    line-height: 24px;
    text-transform: capitalize;
  `,
  alignPendingInfo: css`
    display: flex;
    align-items: center;
  `,
  pendingInfoContainer: css`
    & + div {
      padding-top: 20px;
    }
  `,
  pendingSchoolsContainer: css`
    padding-bottom: 20px;
  `,
  paddingInfoIcon: css`
    padding-right: 10px;
  `,
  paddingSchoolsBottom: css`
    margin-bottom: 16px;
  `,
  manageMyselfMessage: css`
    margin-bottom: 16px;
  `,
  description: css`
    margin-bottom: 32px;
  `,
  revertToDistrict: css`
    padding-top: 8px;
  `,
  manageByParentDisclaimer: css`
    margin-bottom: 40px;
  `,
  changeEmailContainer: css`
    background-color: ${colors.platinum};
    margin-top: 16px;
    gap: 16px;
    padding: 24px 16px;
    border-radius: 10px;
  `,
};

export default styles;
